export default __webpack_public_path__ + "static/media/dep-arr.4d4a609b.png";